import styled from 'styled-components';

export const Wrapper = styled.div<{ isActive: boolean }>`
  background: var(--colorWhite);
  height: 196px;
  width: 196px;
  font-size: 12px;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  border: ${({ isActive }) =>
    isActive ? '2px solid rgb(84, 89, 96);' : '1px solid rgb(213, 215, 216)'};
`;

export const ImageWrapper = styled.div<{ imageSrc?: string }>`
  background: rgb(232, 233, 234);
  background-image: ${({ imageSrc }) => (imageSrc ? `url(${imageSrc})` : 'none')};
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 120px;
  margin-bottom: 8px;
`;

export const Name = styled.div`
  color: var(--colorBlueGray1200);
  font-weight: 600;
  margin-bottom: 2px;
  word-break: break-all;
`;

export const Date = styled.div`
  color: var(--colorBlueGray900);
`;
